import { useLazySelector, useInitialLoading } from 'hooks'
import { Notifications } from 'modules/Notifications/components'

const NotificationsContainer: React.FC = () => {
  const { error, isLoading } = useLazySelector(({ notifications }) => {
    const { error, isLoading } = notifications.userNotifications
    return { error, isLoading }
  })
  const isInitialLoading = useInitialLoading(isLoading)

  return <Notifications error={error} isLoading={isInitialLoading} />
}

export default NotificationsContainer
